import Select from "react-select";

interface DoctorCardProps {
  name: string;
  title: string;
  link: string;
  experience: string;
  avatar: string;
  position: string;
}

export type SelectOption<T> = {
  value: T;
  label: string;
};

interface SelectProps<T> {
  options: SelectOption<T>[];
  selectedValue?: T | null;
  onChange?: (value: T | null) => void;
  onInputChange?: (value: string) => void;
  placeholder?: string;
  isClearable?: boolean;
  className?: string;
  inputClassName?: string;
  isLoading?: boolean;
}

export function SelectWithSearch<T>({
  options,
  selectedValue,
  onChange,
  onInputChange,
  placeholder = "Chọn...",
  isClearable = true,
  className,
  inputClassName,
  isLoading,
}: SelectProps<T>) {
  const selected =
    selectedValue == null
      ? null
      : options.find((o) => o.value === selectedValue) ?? null;

  return (
    <Select
      options={options}
      value={selected}
      onChange={(opt) => onChange?.(opt?.value ?? null)}
      onInputChange={(value, meta) => {
        if (meta.action === "input-change") {
          onInputChange?.(value);
        }
      }}
      placeholder={placeholder}
      isClearable={isClearable}
      isLoading={isLoading}
      classNamePrefix="react-select"
      className={className}
      classNames={{
        placeholder: () =>
          `truncate whitespace-nowrap overflow-hidden text-slate-500`,
        control: () => `${inputClassName ?? ""}`,
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        colors: {
          ...theme.colors,
          primary: "#16A34A",
        },
      })}
      menuPosition="fixed"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      filterOption={() => true}
    />
  );
}
